import React, {useEffect} from "react";
import {Cookie} from "Components/Cookie/";
import {getPageType} from "Helpers/PageHelper";
import {useIsIos} from "Hooks/useIsIos";
import {PageWrapper} from "BaseComponents/Wrappers";
import {useGlobal} from "reactn";
import {ERRORPAGE, MAPPAGE, REPORTTECHNICALISSUEPAGE} from "Consts/pageTypes";
import {HeroSwitcher} from "Components/Hero";

const BasePage = ({model, searchQuery, element}) => {
    const {MobileMenu, CookieData, Id, Alias, FooterData, ...rest} = model;
    const isIos = useIsIos();

    const getAllElems = () => {
        const onPageLoad = () => {
            const blocks = document.querySelectorAll(".transition_list > div");
            if (isIos) {
                const parallaxElem = document.querySelectorAll(".parallax_element");
                const parallaxCount = parallaxElem.length;
                if (parallaxCount > 0) {
                    const blocksCount = blocks.length;
                    blocks.forEach((item, index) => {
                        item.style.zIndex = blocksCount - index;
                    });

                    const pageHeader = document.getElementById("header");
                    if (pageHeader) pageHeader.style.zIndex = blocksCount + 1;
                    const cookiePopup = document.getElementsByClassName("cookie_popup");
                    if (cookiePopup[0] && blocksCount) {
                        cookiePopup[0].style.zIndex = (blocksCount + 1) * 10;
                    }
                }
            }
            const addClassToParent = (item, classList) => {
                classList.forEach((classItem) => {
                    const child =
                        item.children.length > 0
                            ? item.getElementsByClassName(classItem)
                            : undefined;
                    if (child && child.length > 0) {
                        item.classList.add(classItem);
                    }
                });
            };

            const addClassToParentByNexElement = (
                item,
                firstClass,
                blockAfter,
                secondClass
            ) => {
                if (!blockAfter) {
                    return;
                }

                const hasClassFirst =
                    blockAfter.children.length > 0
                        ? blockAfter.getElementsByClassName(firstClass)
                        : undefined;
                const hasClassSecond =
                    blockAfter.children.length > 0
                        ? blockAfter.getElementsByClassName(secondClass)
                        : undefined;

                const hasClass =
                    blockAfter.classList.contains(firstClass) &&
                    blockAfter.classList.contains(secondClass);

                if (
                    (hasClassFirst &&
                        hasClassFirst.length > 0 &&
                        hasClassSecond &&
                        hasClassSecond.length > 0) ||
                    hasClass
                ) {
                    switch (firstClass) {
                        case "withoutHeading": {
                            item.classList.add("withoutHeadingBefore");
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
            };

            blocks.forEach((item, i) => {
                const blockAfter = blocks[i + 1];
                addClassToParent(item, [
                    "pagePuffWrapper",
                    "conceptBlock",
                    "withoutHeading",
                    "infoblock",
                ]);

                addClassToParentByNexElement(
                    item,
                    "withoutHeading",
                    blockAfter,
                    "infoblock"
                );
            });
        };

        if (document.readyState === "complete") {
            onPageLoad();
        } else {
            window.addEventListener("load", onPageLoad, false);
            return () => window.removeEventListener("load", onPageLoad);
        }
    };

    // Anchor smooth scroll
    const smoothScrolltoLelement = (href) => {
        const cleanId = href.replace("#", "");
        const scrollto =
            document.getElementById(cleanId)?.getBoundingClientRect()?.top +
            window.pageYOffset -
            90;
        window.scroll({
            behavior: "smooth",
            left: 0,
            top: scrollto,
        });
    };

    useEffect(() => {
        if (window.location.hash !== "") {
            smoothScrolltoLelement(window.location.hash);
        }

        if (element != undefined) {
            element.style.minHeight = "0px";
            element.style.backgroundImage = Alias == ERRORPAGE && "unset";
        }
        getAllElems();
    }, []);

    const [theme] = useGlobal("theme");

    let bgColor = undefined
    switch (Alias) {
        case MAPPAGE:
        case REPORTTECHNICALISSUEPAGE: {
            bgColor = theme.colors.lightgrey;
            break;
        }
        default:
            break;
    }

    return (
        <>
            <PageWrapper theme={theme} bgColor={bgColor}>
                <HeroSwitcher {...rest} />
                {getPageType(rest, Alias, searchQuery)}</PageWrapper>
            <Cookie {...CookieData} currentPageId={Id}/>
        </>
    );
};

export default BasePage;
